



















































































































































































































































































































































































































import axios from 'axios';
import Vue from 'vue';
import { get } from 'lodash';
import VueTagsInput from '@johmun/vue-tags-input';
import i18n from 'vue-i18n';
import EventBus from '../../eventBus';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';

const debounce = require('debounce');

export default {
    i18n: {
        messages: {
            en: {
                nothreads: 'You don’t have any chats yet. Start a new one.',
                addparticipants: 'Add people to your group',
            },
            de: {
                nothreads: 'Du hast noch keine Chats. Starte einen neuen.',
                addparticipants: 'Mitglieder hinzufügen',
            },
        },
    },
    name: 'Messenger',
    components: {
        VueTagsInput,
        CoUser,
        CoThumbnail,
    },
    data() {
        return {
            usersearch: '',
            users: [],
            searchingUsers: false,
            usersRerender: 0,

            mychats: [],
            nextChatsLink: null,
            loading: false,
            isLoading: false,
            navigationVisibleOnMobile: false,
            windowWidth: 0,

            groupChat: {
                ImageURLKey: 0,
            },

            participants: [],
            participant: '',
            separators: [';'],

            community: [],
        };
    },
    computed: {
        isDesktop() {
            return this.windowWidth >= 768;
        },
    },
    watch: {
        participant: 'usersSearchForGroupChat',
        $route(to, from) {
            if (to.name === 'Chat' || to.name === 'EditChat') {
                this.navigationVisibleOnMobile = true;
            } else {
                this.navigationVisibleOnMobile = false;
            }
        },
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
        this.windowWidth = window.innerWidth;

        if (this.$route.name === 'Chat' || this.$route.name === 'EditChat') {
            this.navigationVisibleOnMobile = true;
        } else {
            this.navigationVisibleOnMobile = false;
        }

        this.getMyChats();
        this.getCommunity();

        EventBus.$on(
            'UPDATE_THREAD',
            (payLoad) => {
                this.getMyChats();
            },
            this
        );
    },
    destroyed() {
        EventBus.$off('UPDATE_THREAD');
    },
    methods: {
        showNewChatModal() {
            this.$refs['newchat-modal'].show();
        },
        showNewGroupModal() {
            this.$refs['newgroup-modal'].show();
        },
        isThereAnyMessage(threadID) {
            const newMessages = get(this.$store, `state.newMessages.MessagesPerThread.${threadID}`);

            return !!newMessages;
        },
        uploadImage() {
            this.$store
                .dispatch('imageUpload', {
                    file: this.groupChat.ImageFile,
                    url: '/upload/image/group-chat-avater',
                })
                .then((response) => {
                    this.groupChat.ImageURL = response;
                    this.createGroupChat();
                })
                .catch((error) => {
                    this.isLoading = false;
                    const errorMsg = {
                        Message: 'Could not upload image, please try again.',
                        Details: error.response.data,
                    };
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.message === 'Request Entity Too Large'
                    ) {
                        errorMsg.Message = 'The file you tried to upload is too large. Max 10 MB.';
                    }
                    EventBus.$emit('ERROR', errorMsg);
                });
        },

        publishGroupChat(event) {
            this.isLoading = true;

            if (this.groupChat.ImageFile != null) {
                this.uploadImage();
            } else {
                this.createGroupChat();
            }
        },

        createGroupChat() {
            const data = new Object(this.groupChat);
            delete data['ImageFile'];
            const participants = [this.$store.state.me.ID];
            this.participants.forEach((element) => {
                participants.push(element.userID);
            });
            data['Participants'] = participants;

            axios({
                method: 'POST',
                url: '/chat/t/group-chat',
                withCredentials: true,
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.$refs['newgroup-modal'].hide();
                        this.getMyChats(response.data.ID);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getCommunity() {
            this.$store
                .dispatch('getCommunity', this.feedNextPage)
                .then((response) => {
                    if (response != null && response.objects != null) {
                        response.objects.forEach((element) => {
                            if (this.$store.state.me.ID !== element.object.ID) {
                                this.community.push(element.object);
                            }
                        });
                        this.users = this.community;
                    }
                })
                .catch((error) => {
                    // todo show error
                });
        },

        previewGroupImage(event) {
            const file = event.target.files[0];
            this.groupChat.ImageURL = URL.createObjectURL(file);
            this.groupChat.ImageFile = file;
            this.groupChat.ImageURLKey++;
        },
        search() {},
        getMyChats(routeTo) {
            this.loading = true;
            let url = '/chat/t/list';
            if (this.$store.state.circlesOn) {
                url = '/chat/t/listV2';
            }
            axios({
                method: 'GET',
                url,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    if (response.data && response.data.objects.length !== 0) {
                        this.mychats = response.data.objects;
                        this.nextChatsLink = response.data.next;
                        if (routeTo != null) {
                            this.$router.replace(`/messenger/${routeTo}`);
                        } else if (this.$route.name !== 'Chat' && this.$route.name !== 'EditChat') {
                            this.$router.push(`messenger/${this.mychats[0].object.ID}`);
                        }
                    }

                    const threads = {};
                    this.mychats.forEach((element, index) => {
                        threads[element.object.ID] = element.object;
                    });
                    this.$store.commit('SET_THREADS', threads);
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },

        usersSearchForGroupChat() {
            if (this.participant === '') {
                return;
            }
            this.users = [];
            axios({
                method: 'GET',
                url: `/search/user/${this.participant}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.users = [];
                        response.data.forEach(function (entry) {
                            if (this.$store.state.me.ID !== entry.ID) {
                                this.users.push(entry);
                            }
                        }, this);
                        this.searchingUsers = false;
                    }
                })
                .catch((error) => {
                    this.users = [];
                    this.searchingUsers = false;
                });
        },

        addUserToGroupChat(user) {
            const participant = {
                text: user.Profile.Name,
                userID: user.ID,
                classes: 'no-before',
            };
            if (!this.isDuplicate(this.participants, participant)) {
                this.participant = '';
                this.participants.push(participant);
            }
        },
        addTag(obj) {
            // made to stop adding by enter
        },
        removeUserFromGroup(index) {
            this.participants.split(index, 1);
        },
        isDuplicate(tags, tag) {
            return tags.map((t) => t.text).indexOf(tag.text) !== -1;
        },

        usersSearchResult: debounce(function (e) {
            this.searchingUsers = true;
            this.users = [];
            axios({
                method: 'GET',
                url: `/search/user/${this.usersearch}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.users = [];
                        response.data.forEach(function (entry) {
                            if (this.$store.state.me.ID !== entry.ID) {
                                this.users.push(entry);
                            }
                        }, this);
                        this.searchingUsers = false;
                    }
                })
                .catch((error) => {
                    this.searchingUsers = false;
                });
        }, 200),

        createThread(user) {
            const thread = {
                Participants: [this.$store.state.me.ID, user.ID],
            };
            axios({
                method: 'POST',
                url: '/chat/t',
                withCredentials: true,
                data: JSON.stringify(thread),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.getMyChats(response.data.ID);
                        this.$refs['newchat-modal'].hide();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
